module.exports = __webpack_public_path__ + "img/T4-C-xs_3.cc2814ea.png";